import Vue from 'vue';
import { apiPath } from '../constants';

const DraftApps = Vue.resource(
  `${apiPath}/draft-apps{/id}{/resource}{/resourceId}{/action}/`,
  {},
  {
    changeState: {
      method: 'POST',
      params: { resource: 'change-state' },
    },
    removePackage: {
      method: 'DELETE',
      params: { resource: 'packages' },
    },
    uploadIcon: {
      method: 'POST',
      params: { resource: 'icon' },
    },
    uploadScreenshot: {
      method: 'POST',
      params: { resource: 'screenshot' },
    },
    deleteScreenshot: {
      method: 'DELETE',
      params: { resource: 'screenshot' },
    },
    uploadPromotionScreenshot: {
      method: 'POST',
      params: { resource: 'promotion-screenshot' },
    },
    deletePromotionScreenshot: {
      method: 'DELETE',
      params: { resource: 'promotion-screenshot' },
    },
    updatePackageArchitecture: {
      method: 'POST',
      params: {
        resource: 'packages',
        action: 'edit-cpu',
      },
    },
    deleteRelease: {
      method: 'DELETE',
      params: { resource: 'release' },
    },
    getRSAKey: {
      method: 'GET',
      params: { resource: 'rsa-key' },
    },
    getDynamicPriceKey: {
      method: 'GET',
      params: { resource: 'dynamic-price-key' },
    },
  },
  {
    transformToCamelCase: true,
  },
);

export default DraftApps;
